export const removeQueryParamValueFromURL = (url = "") => {
  if (!url) {
    return "";
  }

  const formattedUrl = url.replace(/(ssnnumber=[^&]*)/, "ssnnumber=");

  return formattedUrl;
};
